import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { useIntl } from 'react-intl';
import { Loader } from '../../../../_metronic/helpers';

const CategoryModal = ({ show, onHide, onSubmit, category, loading }) => {
    const intl = useIntl();
    const [initialValues, setInitialValues] = useState({});

    useEffect(() => {
        if (category) {
            setInitialValues({
                name: category.name
            });
        } else {
            setInitialValues({});
        }
    }, [category]);

    const handleSubmit = (event, values) => {
        onSubmit(values);
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {category ? intl.formatMessage({ id: 'CATEGORY.ACTIONS.EDIT' }) : intl.formatMessage({ id: 'CATEGORY.LIST.ADD.CATEGORY' })}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AvForm onValidSubmit={handleSubmit} model={initialValues} key={category ? category.id : 'create'}>
                    <div className="mb-3">
                        <label className="form-label">{intl.formatMessage({ id: 'CATEGORY.FIELD.NAME' })}</label>
                        <AvField
                            name="name"
                            className="form-control"
                            placeholder={intl.formatMessage({ id: 'CATEGORY.FIELD.NAME.PLACEHOLDER' })}
                            required
                            errorMessage={intl.formatMessage({ id: 'VALIDATION.REQUIRED_FIELD' })}
                        />
                    </div>
                    <div className="text-end">
                        <Button variant="light" onClick={onHide} className="me-2">
                            {intl.formatMessage({ id: 'GENERAL.CLOSE' })}
                        </Button>
                        <Button variant="primary" type="submit">
                            {intl.formatMessage({ id: 'GENERAL.SUBMIT' })}
                        </Button>
                    </div>
                </AvForm>
            </Modal.Body>
            {loading && <Loader />}
        </Modal>
    );
};

export default CategoryModal;
